(function () {
  'use strict';

  function initRealLifeReal(section) {
    var grid = section.querySelector('[data-rlr-grid]');
    var dotsWrap = section.querySelector('[data-rlr-dots]');
    if (!grid || !dotsWrap) return;

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-rlr-dot]'));
    var cards = Array.prototype.slice.call(grid.children);
    if (!dots.length || !cards.length) return;

    function setActiveByScroll() {
      var gridRect = grid.getBoundingClientRect();
      var gridCenter = gridRect.left + gridRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var rect = card.getBoundingClientRect();
        var cardCenter = rect.left + rect.width / 2;
        var distance = Math.abs(cardCenter - gridCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    var ticking = false;
    grid.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            setActiveByScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var card = cards[index];
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });

    setActiveByScroll();
    window.addEventListener('resize', setActiveByScroll);
  }

  function initAll() {
    document.querySelectorAll('.real-life-real').forEach(initRealLifeReal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.real-life-real');
    if (section) initRealLifeReal(section);
  });
})();
